









































































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import Card from '@/components/Card.vue'
import Table from '@/components/tables/Table.vue'
import { ETableColumnType, ITableConfig } from '@/interfaces'
import { ChainModule } from '@/store/modules/chain.module'
import { EZuntaInvoiceStatus, EZuntaInvoiceType, IFacility, IZuntaInvoice } from '@zunta/configurations'
import Confirm from '@/components/Confirm.vue'
import { getStatementPathByKey } from '@/utils/helpers'
import Icon from '@/components/Icon.vue'
import BillingHistoryModal from './components/BillingHistoryModal.vue'
import RefundInvoiceModal from './components/RefundInvoiceModal.vue'
import { EStatusType } from '@/components/statuses/EStatusType'
import Status from '@/components/statuses/Status.vue'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import ButtonDownloadReport from '@/components/ButtonDownloadReport.vue'
import { downloadFile } from '@/utils/fileHelper'
import RegenerateInvoiceModal from './components/RegenerateInvoiceModal.vue'
import moment from 'moment-timezone'

@Component({
  components: {
    ButtonDownloadReport,
    DateTimeLabel,
    Card,
    Table,
    Confirm,
    Icon,
    BillingHistoryModal,
    RefundInvoiceModal,
    Status,
    RegenerateInvoiceModal
  }
})
export default class InvoicePage extends Vue {
  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store)
  EZuntaInvoiceStatus: any = EZuntaInvoiceStatus
  isBillingInvoices: boolean = false
  shouldConfirmBillInvoices: boolean = false
  isWantRebill: boolean = false
  invoiceToRebill: number | null = null
  isWantRefund: boolean = false
  isWantBill: boolean = false
  invoiceToBill: number | null = null
  invoiceToRefund: number | null = null
  isLoadingReport: boolean = false
  invoiceToEdit: number | null = null
  currentFilters: any = {
    skip: 0,
    limit: 20
  }
  isProcessing: boolean = false
  shouldShowBillingHistory: boolean = false
  historyInvoiceId: number | null = null

  get batchId () {
    return this.$route.params.batch
  }

  get invoices () {
    return this.$store.state.chain.billingInvoices
  }

  get userId () {
    return this.$route.params.user
  }

  get totalInvoices () {
    return this.$store.state.chain.totalInvoices
  }

  config: ITableConfig = {
    useQuery: true,
    usePagination: true,
    rowClick: this.openInvoicePdf,
    fetchFunction: this.fetchInvoices,
    clearFilterBtn: {
      wrapperClass: 'position-absolute',
      wrapperStyle: 'top: calc(-1rem - 1px); right: -1.5rem;',
      class: 'rounded-bottom'
    },
    maxHeight: 'calc(100vh - 400px)',
    minHeight: 'calc(100vh - 400px)',
    columns: [
      {
        minWidth: '250px',
        width: 20,
        key: 'chainFacility',
        searchKey: 'chainFacility',
        hasSort: true,
        hasSearch: true,
        label: 'Chain/Facility',
        type: ETableColumnType.default
      },
      {
        minWidth: '150px',
        width: 8,
        key: 'invoiceDate',
        searchKey: 'dateRange',
        hasSort: true,
        hasSearch: true,
        label: 'Invoice Date',
        type: ETableColumnType.dateRange
      },
      {
        minWidth: '150px',
        width: 7,
        key: 'invoiceType',
        searchKey: 'invoiceType',
        hasSearch: true,
        hasSort: true,
        label: 'Invoice Type',
        type: ETableColumnType.select,
        options: [
          {
            key: 'monthly',
            content: 'Monthly',
            value: EZuntaInvoiceType.MONTHLY
          },
          {
            key: 'cc',
            content: 'Credit Card',
            value: EZuntaInvoiceType.CC
          },
          {
            key: 'eCheck',
            content: 'eCheck',
            value: EZuntaInvoiceType.ECHECK
          },
          {
            key: 'mailing',
            content: 'Mailing',
            value: EZuntaInvoiceType.MAILING
          }
        ]
      },
      {
        class: 'text-right',
        minWidth: '100px',
        width: 8,
        key: 'amount',
        searchKey: 'amount',
        hasSort: true,
        hasSearch: true,
        label: 'Amount',
        type: ETableColumnType.default
      },
      {
        class: 'text-right',
        minWidth: '100px',
        width: 9.5,
        key: 'cost',
        searchKey: 'cost',
        hasSort: true,
        hasSearch: true,
        label: 'Cost',
        type: ETableColumnType.default
      },
      {
        class: 'text-right',
        minWidth: '100px',
        width: 10.5,
        key: 'net',
        searchKey: 'net',
        hasSort: true,
        hasSearch: true,
        label: 'Net',
        type: ETableColumnType.default
      },
      {
        minWidth: '170px',
        width: 17,
        key: 'status',
        searchKey: 'status',
        hasSearch: true,
        hasSort: true,
        label: 'Invoice Status',
        type: ETableColumnType.select,
        options: [
          {
            key: 'paid',
            content: 'Paid',
            value: EZuntaInvoiceStatus.PAID
          },
          {
            key: 'Unbilled',
            content: 'Unbilled',
            value: EZuntaInvoiceStatus.NOT_PAID
          },
          {
            key: 'no-payment-method',
            content: 'No Payment Method',
            value: EZuntaInvoiceStatus.NO_PAYMENT_METHOD
          },
          {
            key: 'rejected-payment',
            content: 'Rejected Payment',
            value: EZuntaInvoiceStatus.REJECTED
          },
          {
            key: 'refund',
            content: 'Refund',
            value: EZuntaInvoiceStatus.REFUND
          }
        ]
      },
      {
        minWidth: '100px',
        width: 10,
        key: 'isDiscrepancy',
        searchKey: 'isDiscrepancy',
        hasSearch: true,
        hasSort: true,
        label: 'Discrepancy',
        type: ETableColumnType.select,
        options: [
          {
            key: 'yes',
            content: 'Yes',
            value: 'true'
          },
          {
            key: 'no',
            content: 'No',
            value: 'false'
          }
        ]
      },
      {
        class: 'text-right',
        minWidth: '100px',
        width: 10,
        key: 'actions',
        type: ETableColumnType.default
      }
    ]
  }

  getStatusType (status: string): EStatusType {
    switch (status) {
      case EZuntaInvoiceStatus.REFUND:
        return EStatusType.pending
      case EZuntaInvoiceStatus.REJECTED:
        return EStatusType.error
      case EZuntaInvoiceStatus.PAID:
        return EStatusType.success
      case EZuntaInvoiceStatus.NO_PAYMENT_METHOD:
        return EStatusType.attention
      default:
        return EStatusType.default
    }
  }

  async rebillInvoice () {
    this.isProcessing = true
    if (this.invoiceToRebill) {
      const res = await this.chainModuleInstance.rebillInvoice(this.invoiceToRebill)
      if (res === 'OK') {
        this.$eventBus.$emit('notify', {
          color: 'var(--status-success-color)',
          message: 'Successfully rebilled',
          header: `Rebill Invoice`,
          icon: 'check'
        })
      } else {
        this.$eventBus.$emit('notify', {
          color: 'var(--status-error-color)',
          message: 'Something went wrong',
          header: `Rebill Invoice`,
          icon: 'warning'
        })
      }
      await this.fetchInvoices(this.currentFilters)
    }
    this.isProcessing = false
    this.invoiceToRebill = null
    this.isWantRebill = false
  }

  async downloadInvoices () {
    this.isLoadingReport = true
    const query = { ...this.currentFilters }
    delete query.limit
    delete query.skip
    query.batch = this.batchId
    if (this.userId) {
      query.user = this.userId
    }
    await downloadFile('/api/billing/download-invoices-sheet', query)
    this.isLoadingReport = false
  }

  async billInvoice () {
    this.isProcessing = true
    if (this.invoiceToBill) {
      const res = await this.chainModuleInstance.billInvoice(this.invoiceToBill)
      if (res === 'OK') {
        this.$eventBus.$emit('notify', {
          color: 'var(--status-success-color)',
          message: 'Successfully billed',
          header: `Bill Invoice`,
          icon: 'check'
        })
      } else {
        this.$eventBus.$emit('notify', {
          color: 'var(--status-error-color)',
          message: 'Something went wrong',
          header: `Bill Invoice`,
          icon: 'warning'
        })
      }
      await this.fetchInvoices(this.currentFilters)
    }
    this.isProcessing = false
    this.invoiceToBill = null
    this.isWantBill = false
  }

  async refundInvoice (options: { type: string, amount: string }) {
    this.isProcessing = true
    if (this.invoiceToRefund) {
      const res = await this.chainModuleInstance.refundInvoice({
        invoice: this.invoiceToRefund,
        options
      })
      if (res === 'OK') {
        this.$eventBus.$emit('notify', {
          color: 'var(--status-success-color)',
          message: 'Successfully refunded',
          header: `Refund Invoice`,
          icon: 'check'
        })
      } else {
        this.$eventBus.$emit('notify', {
          color: 'var(--status-error-color)',
          message: 'Something went wrong',
          header: `Refund Invoice`,
          icon: 'warning'
        })
      }
      await this.fetchInvoices(this.currentFilters)
    }
    this.isProcessing = false
    this.invoiceToRefund = null
    this.isWantRefund = false
  }

  confirmRebill (invoiceId: number) {
    this.isWantRebill = true
    this.invoiceToRebill = invoiceId
  }

  confirmBill (invoiceId: number) {
    this.isWantBill = true
    this.invoiceToBill = invoiceId
  }

  confirmRefund (invoiceId: number) {
    this.isWantRefund = true
    this.invoiceToRefund = invoiceId
  }

  async fetchInvoices (filters: any) {
    this.currentFilters = filters
    const options = {
      batch: this.batchId,
      ...filters
    }
    if (this.userId) {
      options.user = this.userId
    }
    await this.chainModuleInstance.getBillingInvoices(options)
  }

  openInvoicePdf (item: IZuntaInvoice) {
    if (item.pdf) {
      const invoiceDate = moment.utc(item.invoiceDate).format('MM/DD/YYYY')
      const facility: IFacility = item.facility as IFacility
      const name = `${(facility.shortName || facility.name).replace(/( |\s)/g, '_')}-${this.getInvoiceTypeLabel(item.type).replace(/( |\s)/g, '-')}-${invoiceDate}`.replace(/(\/|\\)/g, '.')
      window.open(getStatementPathByKey(item.pdf, name))
    }
  }

  async billInvoices () {
    this.isBillingInvoices = true
    const isSuccess = await this.chainModuleInstance.billInvoices(this.batchId)
    if (isSuccess) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-success-color)',
        message: 'Bill Invoices in process',
        header: `Bill Invoices`,
        icon: 'check'
      })
    } else {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: 'Something went wrong',
        header: `Bill Invoices`,
        icon: 'warning'
      })
    }
    this.isBillingInvoices = false
    this.shouldConfirmBillInvoices = false
  }

  getInvoiceTypeLabel (type: EZuntaInvoiceType) {
    switch (type) {
      case EZuntaInvoiceType.CC:
        return 'Credit Card'
      case EZuntaInvoiceType.ECHECK:
        return 'eCheck'
      case EZuntaInvoiceType.MAILING:
        return 'Mailing'
      case EZuntaInvoiceType.MONTHLY:
        return 'Monthly'
      default:
        return 'Unknown Type'
    }
  }

  getInvoiceStatusLabel (status: EZuntaInvoiceStatus) {
    switch (status) {
      case EZuntaInvoiceStatus.NOT_PAID:
        return 'Unbilled'
      case EZuntaInvoiceStatus.NO_PAYMENT_METHOD:
        return 'No Payment Method'
      case EZuntaInvoiceStatus.PAID:
        return 'Paid'
      case EZuntaInvoiceStatus.REJECTED:
        return 'Rejected Payment'
      case EZuntaInvoiceStatus.REFUND:
        return 'Refund'
      default:
        return 'Unknown Status'
    }
  }

  showHistory (invoiceId: number) {
    this.historyInvoiceId = invoiceId
    this.shouldShowBillingHistory = true
  }
}
